import {
    SELECT_CASE,
    SELECT_REQUEST,
    REQUEST_MINE,
    SET_SEARCH_STRING,
    SELECT_NO_MORE_ARCHIVED_CASES_TO_FETCH
} from '../constants/cases';

const initialState = {
    selectedCaseId: undefined,
    request: REQUEST_MINE,
    searchString: '',
    noMoreArchivedCasesToFetch: false
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SELECT_CASE:
            return {
                ...state,
                selectedCaseId: action.payload
            };
        case SELECT_REQUEST:
            return {
                ...state,
                request: action.payload,
                //The request has been changed to reset noMoreArchivedCasesToFetch
                noMoreArchivedCasesToFetch: false
            };
        case SET_SEARCH_STRING:
            return {
                ...state,
                searchString: action.payload,
                //The search has been changed to reset noMoreArchivedCasesToFetch
                noMoreArchivedCasesToFetch: false
            };
        case SELECT_NO_MORE_ARCHIVED_CASES_TO_FETCH:
        return {
            ...state,
            noMoreArchivedCasesToFetch: action.payload
        };
        default:
            return state;
    }
};
